export default {"id":"icon-store-logo"}